import { render, staticRenderFns } from "./DocumentTableProjects.vue?vue&type=template&id=227feff6&scoped=true"
import script from "./DocumentTableProjects.vue?vue&type=script&lang=ts"
export * from "./DocumentTableProjects.vue?vue&type=script&lang=ts"
import style0 from "./DocumentTableProjects.vue?vue&type=style&index=0&id=227feff6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227feff6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('227feff6')) {
      api.createRecord('227feff6', component.options)
    } else {
      api.reload('227feff6', component.options)
    }
    module.hot.accept("./DocumentTableProjects.vue?vue&type=template&id=227feff6&scoped=true", function () {
      api.rerender('227feff6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/documents/DocumentTableProjects.vue"
export default component.exports